import { render, staticRenderFns } from "./EmployeeRelationship.vue?vue&type=template&id=8024f9c6"
import script from "./EmployeeRelationship.vue?vue&type=script&lang=js"
export * from "./EmployeeRelationship.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRelationship.vue?vue&type=style&index=0&id=8024f9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports